import { render, staticRenderFns } from "./app.vue?vue&type=template&id=2416ad9e"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_cache-loader@4.1.0_webpack@4.47.0__css-load_294f669fab72d5cfe46d5d718e980b17/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports